<template>
    <div :class="wrapperClass">

        <div :class="listWrapperClass">
            <!-- HIDING THIS UNTIL WE HAVE A USE FOR IT -->
            <!-- <div class="font-weight-bold text-muted mb-1 d-flex justify-content-between align-items-center" style="padding-left: 1.25rem; min-height: 1rem;">
                <div>
                    <transition name="fade-fast" mode="out-in">
                        <div v-show="!hideCount && fileCount">{{ fileCount }} files</div>
                    </transition>
                </div>
                <div class="">
                    <transition name="fade-fast" mode="out-in">
                        <b-button v-show="!loading" variant="minimal-primary" size="sm" @click="$emit('request-refresh')">
                            <b-icon icon="arrow-repeat"></b-icon>
                            Refresh
                        </b-button>
                    </transition>
                </div>
            </div> -->
            
            <transition name="fade" mode="out-in">
                <!-- <div v-if="disabled && disabledPlaceholderText" key="disabledPlaceholder" class="text-muted special-text px-3 py-2 bg-gray-150">
                    {{ disabledPlaceholderText }}
                </div> -->
                <div v-if="showListPlaceholder && (loading || !fileCount)" key="placeholder" class="w-100 min-height-100 border rounded d-flex justify-content-center align-items-center">
                    <!-- we actually changed to hide this when empty... just clutter - before was v-if="loading || !fileCount" -->
                    <div class="text-uppercase font-weight-bold text-black-50">
                        <transition name="fade-in" mode="out-in">
                            <b-spinner v-if="loading" key="loadingspinner"></b-spinner>
                            <div v-else class="text-center">
                                <div>Uploaded file{{ allowMultiple ? 's' : ''}} will appear here</div>
                                <div class="small mt-3">No files to show</div>
                            </div>
                        </transition>
                    </div>
                </div>  <!-- animate__animated animate__faster animate__fadeOutDown animate__fadeIn -->
                <div v-else key="filelist">
                    <transition-group name="file-slinger-upload-list" tag="b-list-group">
                    <b-list-group-item 
                        v-for="fileWrapper in allFiles" 
                        :key="fileWrapper.uid" 
                        class="file-slinger-upload-list-item d-flex justify-content-between align-items-center p-0 "
                        :class="smallList ? '' : 'py-2'"
                    >
                        <file-slinger-upload
                            :uid="fileWrapper.uid"
                            :category="fileWrapper.category"
                            :file="fileWrapper.file"
                            :file-data="fileWrapper.fileData"
                            :title="fileWrapper.title"
                            :parent-id="fileWrapper.parentId"
                            live-upload
                            :no-preview="noPreview"
                            :small="smallList"
                            :disabled="disabled"
                            class="w-100"
                            @upload-error="handleUploadError"
                            @completed="handleUploadCompleted"
                            @cancelled="removeFile"
                            @deleted="removeFile"
                            :hideButtonLabels="hideButtonLabels"
                        ></file-slinger-upload>
                    </b-list-group-item>
                    </transition-group>
                </div>
            </transition>
        </div>

        <file-slinger-dropper
            v-if="!hideDropArea"
            :placeholder-text="dropPlaceholderText"
            :drop-text="dropText"
            :accept="localAcceptString"
            :imageMode="imageOnly"
            :multiple="allowMultiple"
            :directory="allowDirectory"
            :input-height="inputHeight"
            :class="inputWrapperClass"
            :disabled="disabled"
            :disabledPlaceholderText="disabledPlaceholderText"
            @input="handleDroppedFiles"
        ></file-slinger-dropper>
        <!-- v-if="!inputDisabled" - we still show if disabled now, but rendered differently inside the component - only hide completely if limitReached -->
        
        <div v-if="!disabled && !hideLimits" :class="metaWrapperClass">
            <!-- 'meta' stuff like size limits, qty limits, etc -->
            <div class="d-flex gap-4 flex-wrap justify-content-start align-items-center">
                <div v-if="imageOnly" class="">Only images allowed</div>
                <div v-if="localMaxItems" class="">Limit: <b>{{localMaxItems}} files</b></div>
                <div v-if="localMaxFilesizeFormatted" class="">Size Limit (each file): <b>{{localMaxFilesizeFormatted}}</b></div>
                <div v-if="localMaxTotalFilesizeFormatted" class="d-flex gap-2 align-items-center">
                    Total Size Limit (all files): 
                    <b>{{localMaxTotalFilesizeFormatted}}</b>
                    <span v-if="remainingTotalFilesizeFormatted">({{ remainingTotalFilesizeFormatted }} remaining)</span>
                    <!-- this works, but looks to similar to a progress bar, so removing
                        <div class="bg-gray-300 position-relative rounded-lg overflow-hidden opacity-60" style="height: 0.7rem; width: 100px; min-width: 100px; max-width: 100px;">
                        <div class="bg-primary-600 position-absolute" style="left: 0; bottom: 0; height: 0.7rem;" :style="{width: `${totalFilesizePercent}%`}"></div>
                    </div> -->
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { FileWrapper, defaultImageAcceptString } from './file_slinger_helpers';
import FileSlingerDropper from './FileSlingerDropper.vue'
import FileSlingerUpload from './FileSlingerUpload.vue'
import { FormatFileSizeHelper, ParseFileSizeHelper } from '../../js/filters-helpers';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';

/* HOW THESE COMPONENTS WORK TOGETHER

FileSlingerDropper is just the input 
- does not do the uploads 
- just provides a drop zone, then emits something to parent (this component) saying what it got

FileSlingerUpload displays and uploads a SINGLE FILE
- if from existingFiles - just displays it
- if its a new file, passed in from this component, it uploads it, then displays it

This component (FileSlingerListUploader)
- manages all the things
- passes files from existing/new dropped files to the FileSlingerUpload
- makes sense to put logic for types of files allowed, sizes, etc. all here

NOTE - this currently only deals with lists/arrays, even if limit is 1
so if your backend only expects a single file, make sure to handle that somewhere else

*/


export default {
    name: 'FileSlingerListUploader',
    components: {
        //BIconArrowRepeat,
        FileSlingerDropper,
        FileSlingerUpload,
    },
    props: {
        category: {
            type: String,
            required: true,
        },
        parentId: {
            type: String,
            required: false,  // required when doing uploads, if this category requires it
        },
        existingFiles: {
            // an ARRAY of objects in stanard S3File API format, if you have any existing ones to add to the list
            type: Array,
            required: false,
        },
        loading: {  // we only pass this from parent since this component doesn't do any loading on its own
            // if parent is still fetching existingFiles, set this true
            type: Boolean,
            default: false,
        },
        disabled: {  // because we'll also use this in forms just to display a list of already-uploaded files
            type: Boolean,
            default: false, 
        },
        maxItems: {  // disables input if we are at max number - default is 10 just to be safe... but you can increase, or set null to allow unlimited
            type: Number,
            default: 10,  // just to be safe... can change if needed
        },
        imageOnly: {  // shortcut for only accepting images - NOT USED IF YOU HAVE SOMETHING IN 'accept' prop
            type: Boolean,
            default: false,
        },
        noPreview: {  // if true, we will not show image preview, even if possible.  normally shows preview based on filetype
            type: Boolean,
            default: false,
        },
        previewMaxHeight: {
            type: String,
            default: '200px',
        },
        accept: {  // Array or string of comma-separated mime-types or .extensions - HTML standard - if array we join to string
            // SUPERCEDES imageOnly
            type: String,
            default: '',
        },
        allowDirectory: {  // allow dropping entire directory -- we likely have no-traverse set in child component so it doesn't traverse into subdirs 
            type: Boolean,
            default: false,
        },
        maxFilesize: {  // max for ONE file - now supports number (bytes) or '10 MB' (if string) - make sure it comes from / matches your backend 
            type: [Number, String],
            default: (1024 * 1024 * 10),  // 10MB?
        },
        maxTotalFilesize: {  // TOTAL of all files - useful for things like email attachments when we have limit of all files combined
            // maybe allow strings here... parse them to size... must be npm package for it...
            type: Number,
            required: false,
        },
        dropText: {
            type: String,
            required: false,  // if not set, the dropper component has a default - 'Drop Here',
        },
        dropPlaceholderText: {
            type: String,
            required: false,  // if not set, the dropper component has a default - 'Drag & Drop Files Here',
        },
        disabledPlaceholderText: {  // if you want to show some placeholder when there are no files and input is disabled, otherwise nothing is shown, no space taken up 
            type: String,
            required: false,
        },
        showListPlaceholder: {  // should we show the 'files will appear here' div for empty list?
            type: Boolean,
            default: false,
        },
        // STYLING PROPS
        inputHeight: {  // height of the drag-n-drop file input area
            type: String,
            default: '200px',
        },
        wrapperClass: {  // the outermost div
            type: [String, Object, Array], 
            default: '',
        },
        inputWrapperClass: {  // the dnd file input area
            type: [String, Object, Array], 
            default: 'w-100',
        },
        listWrapperClass: {  // the file list area
            type: [String, Object, Array], 
            default: 'w-100',
        },
        metaWrapperClass: {
            type: [String, Object, Array],
            default: 'w-100 text-muted font-size-70 text-right',
        },
        hideLimits: {  // hide the limits/meta text 
            type: Boolean,
            default: false,
        },
        hideCount: {  // hide the count of items? - does nothing for now - hiding it anyways
            type: Boolean,
            default: false,
        },
        smallList: {  // if true, renders the list with tighter margins, less text, smaller buttons
            type: Boolean,
            default: false,
        },
        hideButtonLabels: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            lastEmittedUids: [],  // array of file uids that we last notified parent about - for change tracking (NOT ids... those are from backend, but we don't have them unless saved... so for tracking things here, we use uid)
            allFilesByUid: {},  // our 'store' of files - existing / uploading / uploaded - all
            initialExistingFilesHandled: false, // one-way flag to know if we are handling 'existingFiles' prop for the first time - set in created, or from watcher on existingFiles with immediate=true, AFTER setting lastEmittedUids
            hasFilesToUpload: false,  // we set this true when we get new files to upload, then after each file is uploaded we check if any more pending, if not, set false -- then we watch for that to emit 'all-uploaded' event
            // there are other ways to track what is being uploaded, but what we care about here is detecting when there WERE files uploading, and now there are NONE - so we can emit an event.... we care less about which files, etc.
            // pendingUploadUids: new Set(),  // Set (NOT REACTIVE) of uids that are still pending upload - we add to this when we get new files, remove from it when each upload completes OR cancels/errors - make this a property on the FileWrapper instead??? just use data in our store instead?
        }
    },
    computed: {
        allFiles() {
            // return array of all files, ordered by _position
            return sortBy(Object.values(this.allFilesByUid), ['_position']);
        },
        savedFiles() {
            // only ones that ARE SAVED TO BACKEND (done uploading, or previously uploaded)
            return this.allFiles.filter(f => !!f.isSaved);
        },
        fileCount() {
            // for this we count allFiles
            return (this.allFiles && Array.isArray(this.allFiles)) ? this.allFiles.length : 0;
        },
        inputDisabled() {
            return this.disabled || (this.localMaxItems && (this.fileCount >= this.localMaxItems));
        },
        limitReached() {
            // did we hit a limit of total items or total size?  (TODO - add total size)
            const overCount = (this.localMaxItems && (this.fileCount >= this.localMaxItems));
            const overSize = !!this.totalFilesize && !!this.localMaxTotalFilesize && (this.totalFilesize >= this.localMaxTotalFilesize);
            return overCount || overSize;
        },
        hideDropArea() {
            // we WILL show it still if disabled but no files (hide if disabled and has files)
            return this.limitReached || (this.disabled && this.fileCount > 0);
        },
        allowMultiple() {  // if no maxItems, or maxItems is greater than one 
            return !this.localMaxItems || (this.localMaxItems > 1);
        },
        localAcceptString() {  // we set default in prop, but also need to check if this.imageOnly === true
            // this.accept wins over this.imageOnly 
            if (!this.accept) {
                return this.imageOnly ? defaultImageAcceptString : '';  // '' should be default if no restrictions - component expects it 
            } else if (Array.isArray(this.accept)) {
                return this.accept.join(',');
            }
            return this.accept;
        },
        totalFilesize() {
            let size = 0;  // you should use reduce...
            this.allFiles.forEach(f => {
                size = size + f.filesize;
            });
            return size;
        },
        remainingTotalFilesize() {
            return (!!this.totalFilesize && !!this.localMaxTotalFilesize) ? this.localMaxTotalFilesize - this.totalFilesize : null;
        },
        remainingTotalFilesizeFormatted() {
            return this.remainingTotalFilesize ? FormatFileSizeHelper(this.remainingTotalFilesize) : '';
        },
        localMaxItems() {
            // coerce to number
            return this.maxItems ? Number(this.maxItems) : null;
        },
        localMaxFilesize() {
            // make it a number locally -- use our parser helper
            return this.maxFilesize ? ParseFileSizeHelper(this.maxFilesize) : null;
            //return this.maxFilesize ? Number(this.maxFilesize) : null;
        },
        localMaxFilesizeFormatted() {
            // don't show anything if max for each file is same or less than total max
            if (this.localMaxFilesize && this.localMaxTotalFilesize && (this.localMaxFilesize >= this.localMaxTotalFilesize)) {
                return '';
            }
            return this.localMaxFilesize ? FormatFileSizeHelper(this.localMaxFilesize) : '';
        },
        localMaxTotalFilesize() {
            // coerce to number
            return this.maxTotalFilesize ? Number(this.maxTotalFilesize) : null;
        },
        localMaxTotalFilesizeFormatted() {
            return this.localMaxTotalFilesize ? FormatFileSizeHelper(this.localMaxTotalFilesize) : '';
        },
        totalFilesizeFormatted() {
            return this.totalFilesize ? FormatFileSizeHelper(this.totalFilesize) : '';
        },
        totalFilesizePercent() {  // int, out of 100 so we can use in width property 
            if (!this.localMaxTotalFilesize) {
                // if no max, then return 0 
                return 0;
            }
            const ratio = this.totalFilesize / this.localMaxTotalFilesize;
            return Math.round(ratio * 100);
        },
    },
    watch: {
        existingFiles: {  // doing this so we could pass in more files from parent after initial create
            handler: 'handleExistingFiles',
            immediate: true,  // need this in case they're passed in immediately (likely)
        },
        allFilesByUid: {
            handler: 'handleListChange',
            deep: true,  // still need deep: true - we are making changes 1 nested level down... even though we use this.$set
        },
        hasFilesToUpload: {
            handler: function(newVal, oldVal) {
                // we set this true when we get new files to upload, then after each file is uploaded we check if any more pending, if not, set false -- then we watch for that to emit 'all-uploaded' event
                if (oldVal && !newVal) {
                    // changed from true to false - so we had files uploading, and now we don't - emit event
                    this.$emit('all-uploaded');
                }
                // we don't care about false -> true changes or anything else
            }
        },
    },
    methods: {
        // CREATING NEW FileWrapper instances from api/existing
        getNextPosition() {
            // position is 1-based
            return this.allFiles.length + 1;
        },
        handleExistingFiles(existingFileList) {
            // need all this because we have watcher on prop, and if parent passes in new things, we need to handle them 
            const hasExisting = !!existingFileList && Array.isArray(existingFileList) && existingFileList.length;
            if (!hasExisting) return;
            // otherwise continue...
            this.existingFiles.forEach(fileData => {
                const fileWrapper = new FileWrapper({
                    // let a default uid get set
                    _position: this.getNextPosition(),
                    category: this.category,
                    parentId: this.parentId,
                    fileData: fileData,
                    // title?
                });
                if (!this.alreadyHaveThisFile(fileWrapper)) {
                    this.$set(this.allFilesByUid, fileWrapper.uid, fileWrapper);
                }
            });
            if (!this.initialExistingFilesHandled) {
                // we only want this to happen if we had existingFiles as initial value when created...
                this.lastEmittedUids = [...this.getCurrentSavedUids()];
                this.initialExistingFilesHandled = true;  // make sure this is only set one-way
            }
        },
        handleDroppedFiles(fileList) {
            // handle files dropped on the Dropper component - we normalize there so it always emits an array, even if just one file
            // we normalize them, then check if they are allowed, then add to stashedFiles if allowed, which triggers upload 
            console.log(fileList);
            fileList.forEach(file => {
                const fileWrapper = new FileWrapper({
                    // let a default uid get set
                    _position: this.getNextPosition(),
                    category: this.category,
                    parentId: this.parentId,
                    file: file,
                    // title?
                });
                if (this.droppedFileCanUpload(fileWrapper)) {
                    // add new files to top of list or bottom?  use .push() or .unshift()
                    // should match whatever you use in order_by -- otherwise confusing
                    this.hasFilesToUpload = true;  // we have at least one new file to upload now... set this true on each one, then when each upload completes we check if any more pending, if not set false
                    // this.pendingUploadUids.add(fileWrapper.uid);
                    this.$set(this.allFilesByUid, fileWrapper.uid, fileWrapper);
                } else {
                    // if not, we already showed toast messages, just move on
                }
            });
        },
        handleUploadCompleted(payload) {
            // the FileSlingerUpload component emits when it is done with a new upload
            // payload is the response data from api + the 'uid' from the component that did the upload (merge into one object)
            // we need to take that data, make a NEW FileWrapper() WITH THE SAME UID and replace the previous one in 'store'
            console.log('upload complete', payload);
            const { uid, ...apiFileData } = payload;
            const originalPosition = this.allFilesByUid[uid]['_position'];
            const newFileWrapper = new FileWrapper({
                uid: uid,  // USE SAME uid and position!
                _position: originalPosition ?? this.getNextPosition(),  // really should have originalPosition...
                category: this.category,
                parentId: this.parentId,
                fileData: apiFileData,
            }); 
            // now REPLACE the old one that had the file 
            this.$set(this.allFilesByUid, newFileWrapper.uid, newFileWrapper);
        },
        alreadyHaveThisFile(fileWrapperFile) {
            // return Boolean, true if we already have this file in stashedFiles
            // must check using our backend ID, not the local unique ID since those get assigned no matter what
            const fileId = fileWrapperFile.id;  // will only have this if saved, which is what we want
            if (!fileId) return false;  // if file doesn't have id yet, it isn't saved yet, so not a duplicate
            return this.allFiles.some(f => f.id === fileId);  // returns true if there's a matching ID -- we already handled 'undefined' case 
        },
        droppedFileCanUpload(fileWrapperFile) {
            // pass in a file in FileWrapper() - return boolean if allowed based on things in the list
            // for now, we also show toast messages with reasons for not allowing, if any 
            // NOTE - the dropper component will already reject things based on 'accept' - so we should not need to check here!
            // here, we're mainly checking size and count (input is disabled when we are over count, but if max is 2 and user drops 5 files, we need to handle that)
            const size = fileWrapperFile.filesize;
            if (this.localMaxFilesize && (size > this.localMaxFilesize)) {
                this.$toast(`File is too big - limit is ${FormatFileSizeHelper(this.localMaxFilesize)}`);
                return false;
            }
            const newTotalFilesize = this.totalFilesize + size;
            if (this.localMaxTotalFilesize && (newTotalFilesize > this.localMaxTotalFilesize)) {
                this.$toast(`Total filesize will be to over limit (${FormatFileSizeHelper(this.localMaxTotalFilesize)})`);
                return false;
            }
            const newFileCount = this.allFiles.length + 1;
            if (this.localMaxItems && (newFileCount > this.localMaxItems)) {
                this.$toast(`Too many files - limit is ${this.localMaxItems}`);
                return false;
            }
            return true;
        },
        handleUploadError(err) {
            console.log(err);  
            // what else?  removeFile?  if so, have to make sure we got enough info in payload
        },
        removeFile(uid) {
            // remove a file from the list -- because it already deleted itself, or removed before uploading
            // we call this from @cancelled or @deleted -- but in either case, it should be in our store already 
            this.$delete(this.allFilesByUid, uid);
        },
        getCurrentSavedUids() {
            // being explicit about when we call this, so not a computed
            // return an ARRAY of the file UIDs of files that ARE SAVED (ie: done uploading)
            // we don't emit these, but use it for change tracking
            return this.savedFiles.map(f => f.uid);
        },
        getHasAnyUnsavedFiles() {
            // return boolean - true if any files in the list are still uploading / to be uploaded  (isSaved != true)
            // specifically want to check for any unsaved, not that all are saved... because errored will still be unsaved, and we want to know if there's anything left to do
            return this.allFiles.some(f => !f.isSaved);
        },
        handleListChange() {
            // call this from watcher on our 'store'
            // check if our list of saved files has changed, if so, emit updates
            // you COULD add different events, let parents choose what they want to listen to
            // one event for any change/any new upload (maybe only slight differences)
            // one event only when the list of saved files has changed - that's what we'll do here
            const lastEmittedUids = [...this.lastEmittedUids];
            const currentSavedUids = [...this.getCurrentSavedUids()];
            // we care about ordering... in case we are using position in the list for some reason
            // use lodash isEqual to compare -- it also checks position, but can compare 2 different arrays, different than ===
            if (!isEqual(lastEmittedUids, currentSavedUids)) {
                console.log('FILE SLINGER LIST DID CHANGE - last uids, current uids:', lastEmittedUids, currentSavedUids);
                // we only emit the fileData -- same shape as we get from apiResponse / existing files - we make a copy though
                const savedFileData = this.savedFiles.map(fileWrapper => ({...fileWrapper.fileData}));
                this.lastEmittedUids = [...currentSavedUids];  // so we watch for changes next time!
                this.$emit('update', savedFileData);
            }
            // AFTER we have emitted update, we check if we still have any unsaved files... if not, set hasFilesToUpload false
            // then we have a watcher on that to emit 'all-uploaded' event if it changed from true to false
            if (!this.getHasAnyUnsavedFiles()) {
                this.hasFilesToUpload = false;  // if not any unsaved files, set this false, can do it all the time... that triggers watcher only if it changed
            }
        },
    },
}
</script>

<style lang="scss">

.file-input-component {
    // height is set on this
    label.custom-file-label {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-style: dashed;
        background-color: $primary-50;
        span.form-file-text {
            font-weight: 500;
            text-transform: uppercase;
            color: $gray-400;
        }
        &::after {
            // this is the button
            display: none;
        }
        &.dragging {
            // when dragging and over the input .dragging is added
            background-color: $success-50;
            border-style: solid;
            border-color: $success;
            border-width: 3px;
        }
    }
}

// transition-group classes
.file-slinger-upload-list-move {  // the b-list-group-item items
  transition: all 0.5s;
  //bottom: 0;  // ideally you would set the position relative to parent and have it stay in same place, just fade out... later...
  //display: inline-block;
  //margin-right: 10px;
}
.file-slinger-upload-list-enter {  // ENTER
    opacity: 0;
    transform: translateY(30px);
}
.file-slinger-upload-list-leave-to {  // EXIT
  opacity: 0;
  transform: scale(0.3);
}
.file-slinger-upload-list-leave-active {
  position: absolute;  // need this to avoid snapping 
}

</style>
